import MindsetsJsSDK from "mindsets-js-sdk";
import {LoadingAction} from "mindsets-js-sdk/src/react/layout/actions";
import {ErrorMessageAction} from "mindsets-js-sdk/src/react/components/CustomToast/actions";

export const LOADED_ACTION_LOGS = '[action_logs] Loaded action logs';
export const LOADED_ACTION_LOGS_PAGES = '[action_logs] Loaded pages';
export const LOADED_ACTION_LOGS_TOTAL = '[action_logs] Loaded total';
export const LOADED_ACTION_LOGS_CURRENT = '[action_logs] Loaded current';
export const LOADED_ACTION_LOGS_LIMIT = '[action_logs] Loaded limit';

export const LoadActionLogsAction = options => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading action logs')))
        .then(() => MindsetsJsSDK().API.get('action-logs', options))
        .then(response => {
            dispatch(LoadedActionLogsAction(response.items));
            dispatch(LoadedActionLogsCurrentAction(response.pages >= response.current ? response.current : 1));
            dispatch(LoadedActionLogsLimitAction(response.limit));
            dispatch(LoadedActionLogsPagesAction(response.pages));
            dispatch(LoadedActionLogsTotalAction(response.total));
            dispatch(LoadingAction(false));

            return response.items;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const LoadedActionLogsAction = payload => ({
    type: LOADED_ACTION_LOGS,
    payload
});
export const LoadedActionLogsPagesAction = payload => ({
    type: LOADED_ACTION_LOGS_PAGES,
    payload
});
export const LoadedActionLogsTotalAction = payload => ({
    type: LOADED_ACTION_LOGS_TOTAL,
    payload
});
export const LoadedActionLogsCurrentAction = payload => ({
    type: LOADED_ACTION_LOGS_CURRENT,
    payload
});
export const LoadedActionLogsLimitAction = payload => ({
    type: LOADED_ACTION_LOGS_LIMIT,
    payload
});
